import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { ProjectDataPage } from '~/components/projects/project-data-page'
import { useProjectDetail } from '~/components/projects/project-detail'
import { titleFor } from '~/lib/route-title'

/**
 * DADOS DO PROJETO — the read-first ficha (ex-"Configurações"): the
 * project's facts on the page, editing in a per-section modal.
 */
const ProjectDetailsRoute = () => {
  const project = useProjectDetail()

  return <ProjectDataPage project={project} />
}

export const Route = createFileRoute('/_authenticated/$workspaceSlug/projects/$projectId/details')({
  component: ProjectDetailsRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Project data`) }] }),
})
